import React from 'react';
import { useRouter } from 'next/router'

const IFRAME_VARIABLE = 'POP_IS_IFRAME_VIEW';

export const useEditorIframe = () => {
  const [isOpenInIframe, setIsOpenInIframe] = React.useState(false);

  React.useEffect(() => {
    const stored = localStorage.getItem(IFRAME_VARIABLE);
    const fromStorage = stored === '1' || stored === 'true';

    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('iframe-preview') === '1';
    setIsOpenInIframe(fromStorage || fromQuery);
  }, []);

  return isOpenInIframe;
};